<template>
  <div class="container">
    <div class="title">
      <span>修改横幅</span>
      <span class="back" @click="back">
        <i class="iconfont icon-fanhui"></i> 返回
      </span>
    </div>
    <div class="wrap">
      <el-row>
        <el-col
          :lg="16"
          :md="20"
          :sm="24"
          :xs="24">
          <el-form
            v-loading="loading"
            :model="form"
            :rules="rules"
            status-icon
            ref="form"
            label-width="100px"
            @submit.native.prevent>
            <el-form-item label="名称" prop="title">
              <el-input size="medium" v-model="form.title" placeholder="请填合作商名称"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="summary">
              <el-input size="medium" v-model="form.summary" autosize placeholder="请填写简介"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="url">
              <el-input size="medium" v-model="form.url" placeholder="请填写跳转地址URL"></el-input>
            </el-form-item>
            <el-form-item label="LOGO" prop="image1">
              <uploader ref="uploader" v-model="form.image1"/>
              <el-input size="medium" v-model="form.image1" placeholder="合作商未选中LOGO"></el-input>
            </el-form-item>
            <el-form-item label="选中LOGO" prop="image2">
              <uploader ref="uploader" v-model="form.image2"/>
              <el-input size="medium" v-model="form.image2" placeholder="合作商选中LOGO"></el-input>
            </el-form-item>
            
            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm('form')">保 存</el-button>
              <el-button @click="resetForm('form')">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import customApi from '../../models/custom'
import Uploader from '../../../Common/components/file/uploader'
import { CheckUrl } from '../../../Common/validator'

export default {
  components: {
    Uploader,
  },
  props: {
    dataID: {
      type: Number,
    },
  },
  data() {
    const validateTitle = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入合作商名字'))
      }
      callback()
    }

    const validateUrl = (rule, value, callback) => {
      if (value && !CheckUrl(value)) {
        callback(new Error('请输入正确的跳转地址'))
      }
      callback()
    }

    const validateImage = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请添加合作商LOGO'))
      }
      callback()
    }
    return {
      loading: false,
      form: {
        title: '',
        summary: '',
        image1: '',
        image2: '',
        url: '',
      },
      rules: {
        title: [
          { validator: validateTitle, trigger: 'blur', required: true },
        ],
        url: [
          { validator: validateUrl, trigger: 'blur', required: false },
        ],
        image1: [
          { validator: validateImage, trigger: 'blur', required: true },
        ],
      },
    }
  },
  methods: {
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const res = await customApi.edit(this.dataID, this.form)
            if (res.error_code === 0) {
              this.$message.success(`${res.msg}`)
              this.$emit('editClose')
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log('error submit!!')
          this.$message.error('请填写正确的信息')
          return false
        }
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$refs.uploader.reset()
      this.refs.tinymce.clear()
    },
    back() {
      this.$emit('editClose')
    },
  },
  async mounted() {
    this.loading = true
    this.form = await customApi.get(this.dataID)

    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
